<app-header></app-header>
<app-navigation></app-navigation>
<app-alert></app-alert>
<router-outlet></router-outlet>
<app-footer></app-footer>